import { render, staticRenderFns } from "./LoomVideo.vue?vue&type=template&id=57cf5149&scoped=true&"
import script from "./LoomVideo.vue?vue&type=script&lang=js&"
export * from "./LoomVideo.vue?vue&type=script&lang=js&"
import style0 from "./LoomVideo.vue?vue&type=style&index=0&id=57cf5149&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cf5149",
  null
  
)

export default component.exports